import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { firmwareSchema } from "../validations/firmwareSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import FirmwareFormComponent from "../components/FirmwareFormComponent";
import { useNavigate } from "react-router";
import { useAlerts, useLoader } from "../../../../context";
import { debounce, Typography } from "@mui/material";
import { uploadFile } from "../utils/uploadFile";
import { useDebouncedApiCall } from "../../../../hooks";
import { createFirmware } from "../../../../Service/Api/firmware";

const FirmwareFormContainer = () => {
  const { showAlerts } = useAlerts();
  const { call } = useDebouncedApiCall();
  const { register, handleSubmit, control, formState, setValue } = useForm({
    resolver: yupResolver(firmwareSchema),
    mode: "onBlur",
  });
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(0);

  const onCancel = useCallback(
    (e) => {
      e?.preventDefault();
      navigate(".."); // Go back to previous page
    },
    [navigate]
  );

  const debouncedSetProgress = debounce(
    (progress) => setUploading(progress),
    200 // ms delay
  );

  const onSubmit = async (data) => {
    await call(async () => {
      try {
        const { promise } = uploadFile(
          data.build,
          debouncedSetProgress,
          "_firmwareUpload"
        );
        const response = await promise;
        const formData = {
          file_link: response.data,
          version: data.version,
          hash: data.hash,
          forceUpdate: data.forceUpdate,
        };
        const res = await createFirmware(formData);
        showAlerts("Firmware created successfully", null, "success");
        navigate("..");
        return res;
      } catch (error) {
        console.error("Upload failed:", error);
        throw error; // Rethrow to be caught by callApi
      } finally {
        setUploading(0);
      }
    });
  };

  return (
    <React.Fragment>
      {uploading > 0 && (
        <Typography
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            zIndex: 1600,
          }}
        >
          {uploading}%
        </Typography>
      )}
      <FirmwareFormComponent
        register={register}
        control={control}
        handleSubmit={handleSubmit}
        formState={formState}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    </React.Fragment>
  );
};

export default FirmwareFormContainer;
